import { Box, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

interface IPageHeaderActionsProps {
    text: string;
}

export function PageHeaderActions(props: IPageHeaderActionsProps) {
    const { text } = props;

    const muiStyles = makeStyles({
        container: { width: '100%' },
        text: { fontSize: '1.5rem' }
    });

    const { container } = muiStyles(props);

    return (
        <Grid
            className={container}
            container
        >
            <Box>
                <Typography className={text}>
                    {text}
                </Typography>
            </Box>
        </Grid>
    );
}

PageHeaderActions.defaultProps = { text: '---' } as Partial<IPageHeaderActionsProps>;

export default PageHeaderActions;